document.addEventListener('DOMContentLoaded', function () {
  // set the height of the drawer according to the presence of announcement bar
  var desktop_megamenu_padding = document.getElementById('megamenu-drawer');
  var mobile_megamenu_padding = document.getElementById('NavDrawer');
  var stickyHeaderWrap = document.querySelector('.header-sticky-wrapper');
  var mobile_wrapper = document.querySelector('.header-top-strip');
  if (stickyHeaderWrap) {
    let get_desktop_height = stickyHeaderWrap.offsetHeight;
    let get_mobile_height = mobile_wrapper.offsetHeight;
    if (desktop_megamenu_padding) {
      manage_megamenu_height(desktop_megamenu_padding, get_desktop_height);
    }
    if (mobile_megamenu_padding) {
      manage_megamenu_height(mobile_megamenu_padding, get_mobile_height);
    }
  }
  function manage_megamenu_height(element, set_height) {
    element.style.top = set_height + 'px';
  }

  const megamenuLinks = document.querySelectorAll('[data-megamenu="true"]');
  const drawer = document.getElementById('megamenu-drawer');
  const submenuDrawer = document.getElementById('submenu-drawer');
  const removeindex = document.querySelectorAll('.submenu-item  .menu-item');
  var ismegamenuopen = false;

  // Remove active class from all submenus
  function removeActiveSubmenus(selector) {
    const submenus = document.querySelectorAll(selector);
    submenus.forEach((submenu) => submenu.classList.remove('active'));
  }

  // Add click listener to megamenu links
  megamenuLinks.forEach((link) => {
    desktop_megamenu_padding.style.display = 'none';
    link.addEventListener('click', (event) => {
      event.preventDefault();
      desktop_megamenu_padding.style.display = 'block';
      if (!ismegamenuopen) {
        // Open megamenu drawer
        submenuDrawer.classList.remove('open');
        drawer.classList.add('open');
        removeindex.forEach((event) => {
          event.removeAttribute('tabindex');
        });
        ismegamenuopen = true;
      } else {
        submenuDrawer.classList.remove('open');
        drawer.classList.remove('open');
        removeActiveSubmenus('li.submenu-item > .menu-item');
        removeActiveSubmenus('ul.submenu');
        removeActiveSubmenus('.submenu-drawer-image');
        ismegamenuopen = false;
        link.setAttribute('aria-expanded', 'false');
        removeindex.forEach((item) => {
          item.setAttribute('aria-expanded', 'false');
        });
        desktop_megamenu_padding.style.display = 'none';
      }
    });
  });

  // Add click listener to submenu items
  const submenuItems = document.querySelectorAll('li.submenu-item > .menu-item');
  let activeMenuItem = null; // Track the currently active menu item

  submenuItems.forEach((menuItem) => {
    menuItem.setAttribute('aria-expanded', 'false');
    menuItem.addEventListener('click', (event) => {
      let currentValue = menuItem.getAttribute('aria-expanded');
      if (currentValue == 'true') {
        menuItem.setAttribute('aria-expanded', 'false');
      } else {
        menuItem.setAttribute('aria-expanded', 'true');
      }
      const submenu = menuItem.nextElementSibling?.classList.contains('submenu')
        ? menuItem.nextElementSibling
        : null;
      // Check if the next sibling is a submenu
      const drawerImage = submenu
        ? submenu.nextElementSibling?.classList.contains('submenu-drawer-image')
          ? submenu.nextElementSibling
          : null
        : menuItem.nextElementSibling?.classList.contains('submenu-drawer-image')
        ? menuItem.nextElementSibling
        : null; // Check if drawer image exists

      // remove the active submenu-item
      if (activeMenuItem && activeMenuItem !== menuItem) {
        const activeSubmenu = activeMenuItem.nextElementSibling?.classList.contains('submenu')
          ? activeMenuItem.nextElementSibling
          : null;
        const activeDrawerImage = activeSubmenu
          ? activeSubmenu.nextElementSibling?.classList.contains('submenu-drawer-image')
            ? activeSubmenu.nextElementSibling
            : null
          : activeMenuItem.nextElementSibling?.classList.contains('submenu-drawer-image')
          ? activeMenuItem.nextElementSibling
          : null;

        if (activeSubmenu) activeSubmenu.classList.remove('active');
        if (activeDrawerImage) activeDrawerImage.classList.remove('active');
        activeMenuItem.classList.remove('active');
        activeMenuItem.setAttribute('aria-expanded', 'false');
      }

      // Toggle the current submenu and drawer image
      const isActive = menuItem.classList.contains('active');
      menuItem.classList.toggle('active', !isActive);
      if (submenu) submenu.classList.toggle('active', !isActive);
      if (drawerImage) drawerImage.classList.toggle('active', !isActive);

      activeMenuItem = !isActive ? menuItem : null; // Update the active menu item
    });
  });

  const submenu = document.querySelector('li.submenu-item:last-of-type');
  submenu.addEventListener('focusout', (event) => {
    submenuDrawer.classList.remove('open');
    drawer.classList.remove('open');
    removeActiveSubmenus('li.submenu-item > .menu-item');
    removeActiveSubmenus('ul.submenu');
    removeActiveSubmenus('.submenu-drawer-image');
    removeindex.forEach((event) => {
      event.setAttribute('tabindex', '-1');
    });
    ismegamenuopen = false;
  });

  // Add click listener to submenu links for activating sub-submenus
  const submenuLinks = document.querySelectorAll('ul.submenu li > .menu-item');
  submenuLinks.forEach((link) => {
    link.setAttribute('aria-expanded', 'false');
    link.addEventListener('click', (event) => {
      // event.preventDefault();
      link.setAttribute('aria-expanded', 'true');
      submenuLinks.forEach((item) => {
        item.classList.remove('active');
        item.setAttribute('aria-expanded', 'false');
      });
      link.classList.add('active');
      // Find the corresponding sub-submenu
      const parentItem = link.closest('li');
      const subSubmenu = parentItem.querySelector('ul.sub-submenu');
      if (subSubmenu) {
        // Remove active class from all other sub-submenus
        removeActiveSubmenus('ul.sub-submenu');
        link.setAttribute('aria-expanded', 'false');
        // Add active class to the clicked sub-submenu
        subSubmenu.classList.add('active');
      }
    });
  });

  // Close drawers when clicking outside
  document.addEventListener('click', (event) => {
    if (
      !drawer.contains(event.target) &&
      !submenuDrawer.contains(event.target) &&
      !event.target.matches('[data-megamenu="true"]') &&
      !event.target.closest('li.submenu-item') &&
      !event.target.classList.contains('submenu-arrow')
    ) {
      ismegamenuopen = false;
      drawer.classList.remove('open');
      submenuDrawer.classList.remove('open');
      removeActiveSubmenus('ul.submenu'); // Remove active class from submenus
      removeActiveSubmenus('ul.sub-submenu'); // Remove active class from sub-submenus
      document.querySelectorAll('.submenu-drawer-image').forEach(function (item) {
        item.classList.remove('active');
      });
      desktop_megamenu_padding.style.display = 'none';
    }
  });
  // aria-expanded Remove from Open/Close Menu button Mobile
  $('#HeaderWrapper #SiteHeader .header-item .site-nav .burger_menu_mobile').removeAttr(
    'aria-expanded'
  );
  $('#HeaderWrapper #SiteHeader .header-item .site-nav .burger_menu_mobile').on(
    'click',
    function () {
      if ($(this).attr('aria-expanded')) {
        $(this).removeAttr('aria-expanded');
      }
    }
  );
});
